export class HudView {
  constructor(container, { onPause, onMoveLeft, onMoveRight, onJump }) {
    this.container = container;
    this.onPause = onPause;
    this.onMoveLeft = onMoveLeft;
    this.onMoveRight = onMoveRight;
    this.onJump = onJump;

    this.element = null;
    this.scoreValEl = null;
    this.distValEl = null;
    this.orbValEl = null;

    this.lastScore = -1;
    this.lastDistance = -1;
    this.lastOrbs = -1;

    this.init();
  }

  init() {
    this.element = document.createElement('div');
    this.element.className = 'ui-view hud-view hidden';
    this.element.style.pointerEvents = 'none'; // Allow canvas touch behind except for buttons
    this.element.style.justifyContent = 'space-between';
    this.element.style.padding = '16px';

    // Top Header Bar
    const topBar = document.createElement('div');
    topBar.style.display = 'flex';
    topBar.style.alignItems = 'center';
    topBar.style.justifyContent = 'space-between';
    topBar.style.width = '100%';
    topBar.style.maxWidth = '900px';
    topBar.style.margin = '0 auto';

    // Score Group
    const scoreCard = document.createElement('div');
    scoreCard.className = 'card-panel';
    scoreCard.style.padding = '8px 18px';
    scoreCard.style.display = 'flex';
    scoreCard.style.alignItems = 'baseline';
    scoreCard.style.gap = '8px';
    scoreCard.style.pointerEvents = 'auto';

    const scoreLabel = document.createElement('span');
    scoreLabel.className = 'text-muted';
    scoreLabel.style.fontSize = '0.85rem';
    scoreLabel.style.fontWeight = '700';
    scoreLabel.textContent = 'SCORE';

    this.scoreValEl = document.createElement('span');
    this.scoreValEl.className = 'tabular-num';
    this.scoreValEl.style.fontSize = '1.6rem';
    this.scoreValEl.style.fontWeight = '800';
    this.scoreValEl.style.color = 'var(--color-primary)';
    this.scoreValEl.textContent = '0';

    scoreCard.appendChild(scoreLabel);
    scoreCard.appendChild(this.scoreValEl);
    topBar.appendChild(scoreCard);

    // Stats Group (Distance & Orbs)
    const statsCard = document.createElement('div');
    statsCard.className = 'card-panel';
    statsCard.style.padding = '8px 16px';
    statsCard.style.display = 'flex';
    statsCard.style.alignItems = 'center';
    statsCard.style.gap = '16px';
    statsCard.style.pointerEvents = 'auto';

    // Distance
    const distBox = document.createElement('div');
    distBox.style.display = 'flex';
    distBox.style.alignItems = 'baseline';
    distBox.style.gap = '4px';

    const distLabel = document.createElement('span');
    distLabel.className = 'text-muted';
    distLabel.style.fontSize = '0.75rem';
    distLabel.textContent = 'DIST';

    this.distValEl = document.createElement('span');
    this.distValEl.className = 'tabular-num';
    this.distValEl.style.fontWeight = '700';
    this.distValEl.textContent = '0m';

    distBox.appendChild(distLabel);
    distBox.appendChild(this.distValEl);
    statsCard.appendChild(distBox);

    // Orbs
    const orbBox = document.createElement('div');
    orbBox.style.display = 'flex';
    orbBox.style.alignItems = 'baseline';
    orbBox.style.gap = '4px';

    const orbLabel = document.createElement('span');
    orbLabel.style.color = 'var(--color-collectible)';
    orbLabel.textContent = '⚡';

    this.orbValEl = document.createElement('span');
    this.orbValEl.className = 'tabular-num';
    this.orbValEl.style.fontWeight = '700';
    this.orbValEl.style.color = 'var(--color-collectible)';
    this.orbValEl.textContent = '0';

    orbBox.appendChild(orbLabel);
    orbBox.appendChild(this.orbValEl);
    statsCard.appendChild(orbBox);

    topBar.appendChild(statsCard);

    // Pause Button
    const pauseBtn = document.createElement('button');
    pauseBtn.className = 'btn-secondary';
    pauseBtn.style.padding = '8px 14px';
    pauseBtn.style.fontSize = '1.1rem';
    pauseBtn.style.pointerEvents = 'auto';
    pauseBtn.setAttribute('aria-label', 'Pause game');
    pauseBtn.textContent = '⏸';
    pauseBtn.onclick = () => this.onPause();
    topBar.appendChild(pauseBtn);

    this.element.appendChild(topBar);

    // Mobile On-Screen Touch Controls (Shown on touch devices / narrow screens)
    const mobileControls = document.createElement('div');
    mobileControls.className = 'mobile-controls';
    mobileControls.style.display = 'flex';
    mobileControls.style.justifyContent = 'space-between';
    mobileControls.style.alignItems = 'flex-end';
    mobileControls.style.width = '100%';
    mobileControls.style.maxWidth = '600px';
    mobileControls.style.margin = '0 auto';
    mobileControls.style.padding = '8px';
    mobileControls.style.pointerEvents = 'none';

    // Left/Right buttons
    const navGroup = document.createElement('div');
    navGroup.style.display = 'flex';
    navGroup.style.gap = '12px';
    navGroup.style.pointerEvents = 'auto';

    const leftBtn = document.createElement('button');
    leftBtn.className = 'btn-secondary';
    leftBtn.style.width = '56px';
    leftBtn.style.height = '56px';
    leftBtn.style.fontSize = '1.4rem';
    leftBtn.setAttribute('aria-label', 'Move Left');
    leftBtn.textContent = '◀';
    leftBtn.onclick = (e) => {
      e.stopPropagation();
      this.onMoveLeft();
    };

    const rightBtn = document.createElement('button');
    rightBtn.className = 'btn-secondary';
    rightBtn.style.width = '56px';
    rightBtn.style.height = '56px';
    rightBtn.style.fontSize = '1.4rem';
    rightBtn.setAttribute('aria-label', 'Move Right');
    rightBtn.textContent = '▶';
    rightBtn.onclick = (e) => {
      e.stopPropagation();
      this.onMoveRight();
    };

    navGroup.appendChild(leftBtn);
    navGroup.appendChild(rightBtn);
    mobileControls.appendChild(navGroup);

    // Jump Button
    const jumpBtn = document.createElement('button');
    jumpBtn.className = 'btn-primary';
    jumpBtn.style.width = '72px';
    jumpBtn.style.height = '56px';
    jumpBtn.style.fontSize = '1.1rem';
    jumpBtn.style.fontWeight = '800';
    jumpBtn.style.pointerEvents = 'auto';
    jumpBtn.setAttribute('aria-label', 'Jump');
    jumpBtn.textContent = 'JUMP';
    jumpBtn.onclick = (e) => {
      e.stopPropagation();
      this.onJump();
    };
    mobileControls.appendChild(jumpBtn);

    this.element.appendChild(mobileControls);
    this.container.appendChild(this.element);
  }

  updateMetrics(score, distance, orbs) {
    if (score !== this.lastScore) {
      this.scoreValEl.textContent = String(score);
      this.lastScore = score;
    }
    if (distance !== this.lastDistance) {
      this.distValEl.textContent = `${distance}m`;
      this.lastDistance = distance;
    }
    if (orbs !== this.lastOrbs) {
      this.orbValEl.textContent = String(orbs);
      this.lastOrbs = orbs;
    }
  }

  show() {
    this.element.classList.remove('hidden');
  }

  hide() {
    this.element.classList.add('hidden');
  }
}
